<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('orders')"
      :columns="columns"
      :column_search="true"
      resource_url="/order/order/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <order-modal ref="order_modal" @success="refresh" />
    <order-detail-modal ref="order_detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import OrderModal from "./order_modal/Index.vue";
import OrderDetailModal from "./order_detail_modal/Index.vue";

export default {
  name: "OrdersDatatable",
  components: { GenericTable, OrderModal, OrderDetailModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("customer"),
          searchable: false,
          name: "$customer.name$",
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.customer?.name || "";
          },
        },
        {
          title: v.$t("total"),
          searchable: false,
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total) || 0;
          },
        },
        {
          title: v.$t("payment"),
          searchable: false,
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="tags has-addons">
                      <span class="tag is-primary">${v.$t(
                        row.payment_method || "not set"
                      )}</span>
                      <span class="tag is-dark">${v.$t(
                        row.payment_status || "unpaid"
                      )}</span>
                    </div>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<span class="tag is-dark">${v.$t(row.status)}</span>`;
          },
        },
        {
          title: v.$t("source"),
          searchable: false,
          // width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.source;
          },
        },
        // {
        //   title: v.$t("profile"),
        //   searchable: false,
        //   // width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name;
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_detail_modal.show(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/order/order", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.order_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
